export default "__VITE_ASSET__9e1d9328__"